var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"container-form-reset-password",attrs:{"fluid":""}},[_c('Form-new-password',{attrs:{"conten":_vm.formulario}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }